import { pluck } from 'rxjs/operators';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
const closeBidMutation = gql`mutation closeBid($closeBid: BidInput!){
  closeBid(details: $closeBid){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class CloseBidService {

  constructor(private apollo: Apollo) { }

  closeBid(closeBid: any){
    return this.apollo.use('external').mutate({
      mutation: closeBidMutation,
      variables: {
        closeBid
      }
    }).pipe(pluck('data', 'closeBid', 'id')).toPromise();
  }
}
